import * as React from 'react';
import { interpolateString } from '@utils/string';
import { DOCUMENTATION_LINK_LABEL } from '@constants/common';
import { DOCS_PIPELINES_LINK, EMPTY_PIPELINES_PAGE_SECTION } from '@constants/pipelines';
import { PermissionAction, PermissionAsset } from '@redux/types/types';
import Authorized from '@components/common/Authorized/Authorized';
import EmptyPageDescription from '@components/emptyPageDescription/EmptyPageDescription';
import RenderCreatePipelineDropdown from '@components/RenderCreatePipelineDropdown/RenderCreatePipelineDropdown';

const PipelinesLandingSVG = React.lazy(() => import('@assets/empty/pipelines-landing.svg?react'));

interface Props {
  handleMenuCreatePipelineClick: () => void;
  totalPipelines: number;
  isLimitedUser: boolean;
}

const RenderEmptyPipelineState: React.FC<Props> = ({
  handleMenuCreatePipelineClick,
  totalPipelines,
  isLimitedUser,
}) => {
  return (
    <EmptyPageDescription
      title={EMPTY_PIPELINES_PAGE_SECTION.TITLE}
      description={EMPTY_PIPELINES_PAGE_SECTION.DESCRIPTION.map(({ paragraph }) => ({
        paragraph: interpolateString(paragraph, {
          documentationLink: (
            <a href={DOCS_PIPELINES_LINK} target="_blank" rel="noreferrer">
              {DOCUMENTATION_LINK_LABEL}
            </a>
          ),
        }),
      }))}
      image={<PipelinesLandingSVG />}
      action={
        <Authorized
          requiredPermissions={{ [PermissionAsset.PIPELINES]: PermissionAction.WRITE }}
          renderAsDisabled
        >
          <RenderCreatePipelineDropdown
            totalPipelines={totalPipelines}
            isLimitedUser={isLimitedUser}
            handleMenuCreatePipelineClick={handleMenuCreatePipelineClick}
          />
        </Authorized>
      }
    />
  );
};

export default RenderEmptyPipelineState;
